<ng-container *transloco="let t; read 'home.calculator.country'" [formGroup]="formGroup">
  <psc-select
    *ngIf="this.advanced"
    [formControlName]="name"
    [label]="t('title')"
    [infoText]="t('info')"
    [options]="[
    { label: t('options.hr'), value: PriceCountry.HR },
    { label: t('options.ba_fe'), value: PriceCountry.BA_FE },
    { label: t('options.ba_rs'), value: PriceCountry.BA_RS },
    ]"></psc-select>

</ng-container>
